module.exports = __webpack_public_path__ + "img/ABC.a31c59fa.svg";